import { render, staticRenderFns } from "./QuestionCardForCountries.vue?vue&type=template&id=15d216fe&"
import script from "./QuestionCardForCountries.vue?vue&type=script&lang=ts&"
export * from "./QuestionCardForCountries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports